module.exports = __webpack_public_path__ + "static/img/008.746b85e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-headquarters/008.png
// module id = EqTZ
// module chunks = 1